module.exports = __webpack_public_path__ + "img/grand-palm-beach.42caaaa9.jpg";